import React from 'react';
import { MenuItem } from '@material-ui/core';
import { getPrimary } from '../styles/colors';
import { isMobile } from '../utils/screen';
import SelectInput from './SelectInput';
import { getText } from '../template/utils/functions';

const MenuItemTabs = ({
	items,
	selected,
	setSelected,
	translate,
	colorSelected,
	goToPadre
}) => {
	const set = item => {
		setSelected(item.value);
		if (goToPadre) {
			goToPadre(item.value);
		}
	};

	if (isMobile) {
		return (
			<SelectInput
				value={selected}
				onChange={event => set(event.target.value.value)}
				styles={{ marginTop: '0px', color: getPrimary() }}
			>
				{items.map((item, index) => (
					<MenuItem key={item.value + index} value={item.value}>{getText(item, translate)}</MenuItem>
				))}
			</SelectInput>
		);
	}
	return (
		<div style={{ marginTop: '1em' }}>
			<div style={{
				display: 'flex',
				padding: '1em',
				justifyContent: 'space-between',
				paddingTop: '0px',
				alignItems: 'center',
				paddingLeft: '0'
			}}>
				<div style={{ fontSize: '13px' }}>
					<div style={{
						height: '100%',
						fontWeight: 'bold',
						padding: '0.7em',
						display: 'flex',
						borderRadius: '5px',
						boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
						color: getPrimary()
					}}>
						{items.map((item, index) => (
							<div
								key={index}
								style={{
									cursor: 'pointer',
									paddingRight: '0.5em',
									paddingLeft: '0.5em',
									color: selected === item.value ? colorSelected || getPrimary() : '#9f9a9d',
									borderRight: index === items.length - 1 ? '' : '1px solid gainsboro'
								}}
								onClick={() => set(item)}
							>
								{getText(item, translate)}
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};


export default MenuItemTabs;
